const Data = {
  'Básico': [
    {
      index: 1,
      category: 'module1',
      options: [
        {
          id: "bolillo",
          name: "Bolillo",
          price: '2,000,000',
          included: true,
          quote_text: 'Módulo 1 - Bolillo',
          image: require("../assets/icons/piso1/espacio_closet.webp")
        },
        {
          id: "escritorio",
          name: "Escritorio",
          price: '1,800,000',
          included: true,
          quote_text: 'Módulo 1 - Escritorio',
          image: require("../assets/icons/piso1/espacio_escritorio.webp")
        },
      ]
    },
    {
      index: 2,
      category: 'module2',
      options: [
        {
          id: "bolillo",
          name: "Bolillo",
          price: '2,000,000',
          included: true,
          quote_text: 'Módulo 2 - Bolillo',
          image: require("../assets/icons/piso1/espacio_closet.webp")
        },
        {
          id: "cajonera",
          name: "Cajonera",
          price: '2,700,000',
          included: true,
          quote_text: 'Módulo 2 - Cajonera',
          image: require("../assets/icons/piso1/espacio_closet+cajonera.webp")
        },
        {
          id: "murphy",
          name: "Murphy",
          price: '6,000,000',
          included: true,
          quote_text: 'Módulo 2 - Murphy',
          image: require("../assets/icons/piso1/espacio_cama.webp")
        },
        {
          id: "escritorio",
          name: "Escritorio",
          price: '1,800,000',
          included: true,
          quote_text: 'Módulo 2 - Escritorio',
          image: require("../assets/icons/piso1/espacio_escritorio.webp")
        },
        {
          id: "sinmurphy",
          name: "Sin Murphy",
          price: '0',
          included: false,
          quote_text: 'Módulo 2 - Sin Murphy',
          image: require("../assets/icons/piso1/espacio_vacio.webp")
        },
      ]
    },
    {
      index: 3,
      category: 'module3',
      options: [
        {
          id: "bolillo",
          name: "Bolillo",
          price: '2,000,000',
          included: true,
          quote_text: 'Módulo 3 - Bolillo',
          image: require("../assets/icons/piso1/espacio_closet.webp")
        },
        {
          id: "cajonera",
          name: "Cajonera",
          price: '2,700,000',
          included: true,
          quote_text: 'Módulo 3 - Cajonera',
          image: require("../assets/icons/piso1/espacio_closet+cajonera.webp")
        },
        {
          id: "murphy",
          name: "Murphy",
          price: '6,000,000',
          included: true,
          quote_text: 'Módulo 3 - Murphy',
          image: require("../assets/icons/piso1/espacio_cama.webp")
        },
        {
          id: "escritorio",
          name: "Escritorio",
          price: '1,800,000',
          included: true,
          quote_text: 'Módulo 3 - Escritorio',
          image: require("../assets/icons/piso1/espacio_escritorio.webp")
        },
        {
          id: "sinmurphy",
          name: "Sin Murphy",
          price: '0',
          included: false,
          quote_text: 'Módulo 3 - Sin Murphy',
          image: require("../assets/icons/piso1/espacio_vacio.webp")
        },
      ]
    },
    {
      index: 4,
      category: 'module4',
      options: [
        {
          id: "cajonera",
          name: "Cajonera",
          price: '2,700,000',
          included: true,
          quote_text: 'Módulo 4 - Cajonera',
          image: require("../assets/icons/piso1/espacio_closet+cajonera.webp")
        },
        {
          id: "escritorio",
          name: "Escritorio",
          price: '1,800,000',
          included: true,
          quote_text: 'Módulo 4 - Escritorio',
          image: require("../assets/icons/piso1/espacio_escritorio.webp")
        },
        {
          id: "cocina",
          name: "Cocina",
          price: '2,300,000',
          included: false,
          quote_text: 'Módulo 4 - Cocina .45',
          image: require("../assets/icons/piso1/espacio_almacenamiento.webp")
        },
      ]
    }
  ],
  'Desmontable': [
    {
      index: 1,
      category: 'module1',
      options: [
        {
          id: "escritorio",
          name: "Escritorio Sencillo",
          price: '900,000',
          included: false,
          quote_text: 'Módulo 1 - Escritorio Sencillo',
          image: require("../assets/icons/mezanine/mezanine-escritorio.webp")
        },
        {
          id: "nodesk",
          name: "Sin Escritorio",
          price: '0',
          included: false,
          quote_text: 'Módulo 1 - Sin Escritorio',
          image: require("../assets/icons/mezanine/mezanine-noescritorio.webp")
        }
        // {
        //   id: "bolillo",
        //   name: "Bolillo Superior",
        //   price: '1,000,000',
        //   included: false,
        //   quote_text: 'Módulo 1 - Bolillo Superior',
        //   image: require("../assets/icons/mezanine/mezanine-noescritorio.webp")
        // }
      ]
    },
    {
      index: 2,
      category: 'module2',
      options: [
        {
          id: "lavamanos",
          name: "Lavamanos",
          price: '3,500,000',
          included: false,
          quote_text: 'Módulo 2 - Lavamanos + Cajonera',
          image: require("../assets/icons/mezanine/mezanine-lavamanos.webp")
        },
        {
          id: "cajonera",
          name: "Bolillo Superior",
          price: '1,000,000',
          included: false,
          quote_text: 'Módulo 2 - Bolillo Superior',
          image: require("../assets/icons/mezanine/mezanine-closet.webp")
        },
      ]
    }
  ]


}

module.exports = { Data };